import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-curveup",
  "use": "icon-curveup-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-trending-up\" id=\"icon-curveup\">\n    <polyline points=\"22 7 13.5 15.5 8.5 10.5 2 17\" />\n    <polyline points=\"16 7 22 7 22 13\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol